import { extendTheme, } from '@chakra-ui/react'
import { ESKlarheitKurrent, inter } from '@/app/fonts'

export const theme = extendTheme({
  fonts: {
    heading: ESKlarheitKurrent.style.fontFamily,
    body: inter.style.fontFamily,
  },
})
